const validateHasTooManyImages = (allMedia: any[]) => {
  if (allMedia.length > 15) {
    throw new Error('tooMany')
  }
}

export { validateHasTooManyImages }
